import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Experience from "@/pages/Experience";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Experience />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
